import React from "react";
import LegalLayout from "../components/LegalLayout";

const Terms = () => {
  return (
    <LegalLayout title="Terms of Service">
      <p>
        These Terms of Service govern your access to and use of the Intlrr
        website, programs, and services. By using this website or enrolling in
        any program, you agree to these terms.
      </p>

      <h2>1. About Intlrr</h2>
      <p>
        Intlrr is an education-focused platform offering cohort-based programs in
        finance, including equity research, financial modeling, fixed income,
        credit analysis, and related domains. All offerings are intended solely
        for educational and skill development purposes.
      </p>

      <h2>2. Eligibility</h2>
      <p>
        You must be at least 18 years old to enroll in any program, or have the
        consent of a parent or legal guardian.
      </p>

      <h2>3. Use of Content</h2>
      <p>
        All course materials, recordings, documents, and resources provided by
        Intlrr are for personal use only. Sharing, copying, redistributing, or
        reselling any content is strictly prohibited.
      </p>

      <h2>4. Educational Disclaimer</h2>
      <p>
        Intlrr does not provide investment advice, financial advisory services,
        or guarantees of job placement, compensation, or investment returns.
        Any decisions made based on the learning are entirely your own
        responsibility.
      </p>

      <h2>5. Payments and Refunds</h2>
      <p>
        Payments, cancellations, and refunds are governed by our Cancellation &
        Refund Policy. Please refer to that page for complete details.
      </p>

      <h2>6. Code of Conduct</h2>
      <p>
        Participants are expected to behave professionally during live
        sessions, discussions, and mentor interactions. Intlrr reserves the
        right to suspend or terminate access in cases of misconduct, without
        refund.
      </p>

      <h2>7. Intellectual Property</h2>
      <p>
        All content, branding, logos, and materials are the intellectual
        property of Intlrr. Unauthorized use may result in legal action.
      </p>

      <h2>8. Limitation of Liability</h2>
      <p>
        Intlrr shall not be liable for any direct or indirect losses arising from
        participation in programs or use of this website, including financial
        or career-related outcomes.
      </p>

      <h2>9. Changes to Services</h2>
      <p>
        Intlrr may modify program content, structure, mentors, or schedules when
        necessary. Any material changes will be communicated to participants.
      </p>

      <h2>10. Governing Law</h2>
      <p>
        These terms are governed by the laws of India. Any disputes shall be
        subject to the jurisdiction of Indian courts.
      </p>

      <h2>11. Contact</h2>
      <p>
        For questions regarding these terms, please contact us via the Contact
        page on this website.
      </p>
    </LegalLayout>
  );
};

export default Terms;
